(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const q = selector => root.querySelector(selector);
    const all = selector => [...root.querySelectorAll(selector)];
    const variant = JSON.parse(q('[data-hammock-variant]').textContent);
    const route = window.Shopify?.routes?.root || '/';
    const money = cents => new Intl.NumberFormat(root.dataset.locale || 'en', {style:'currency',currency:root.dataset.currency || 'USD'}).format(cents / 100);
    const coupon = q('[data-coupon]'), couponSlot = q('[data-coupon-slot]');
    const couponKey = `tenlove-cat-hammock-coupon:${root.dataset.product}:${q('[data-copy-code]').dataset.copyCode}`;
    try {coupon.hidden = sessionStorage.getItem(couponKey) === 'dismissed';} catch (_) {}
    // A reserved slot prevents layout jumps when the theme's overflow requires fixed positioning.
    const measureCoupon = () => {
      const height = `${Math.ceil(coupon.getBoundingClientRect().height)}px`;
      couponSlot.hidden = coupon.hidden;
      couponSlot.style.height = height;
      root.style.setProperty('--tlh-coupon-height', height);
    };
    const couponObserver = new ResizeObserver(measureCoupon);
    couponObserver.observe(coupon);
    measureCoupon();
    const couponPositionObserver = new IntersectionObserver(entries => {
      coupon.classList.toggle('is-pinned', !coupon.hidden && entries[0].boundingClientRect.top < 0);
    }, {threshold:[0,1]});
    couponPositionObserver.observe(couponSlot);
    q('[data-dismiss-coupon]').addEventListener('click', () => {
      coupon.hidden = true;
      coupon.classList.remove('is-pinned');
      try {sessionStorage.setItem(couponKey, 'dismissed');} catch (_) {}
      measureCoupon();
      q('[data-gallery-track]').focus({preventScroll:true});
    });
    let quantity = 1, busy = false;
    const saved = history.state?.tenloveCatHammock;
    if (saved?.product === root.dataset.product && [1,2].includes(saved.quantity)) quantity = saved.quantity;
    const allowed = () => variant.available && (!variant.tracked || variant.policy === 'continue' || variant.stock >= quantity);
    const each = () => variant.price - (quantity === 2 ? Math.floor(variant.price * .15) : 0);
    const hasComparePrice = Number(variant.compareAtPrice) > variant.price;
    const referenceEach = hasComparePrice ? Number(variant.compareAtPrice) : variant.price;
    const updateCompare = (element, reference, current, label) => {
      element.hidden = reference <= current;
      element.textContent = money(reference);
      element.setAttribute('aria-label', label);
    };
    const update = () => {
      all('[name="hammock_bundle"]').forEach(input => {
        input.checked = Number(input.value) === quantity;
        input.closest('label').classList.toggle('is-selected', input.checked);
        input.disabled = busy || !variant.available || (variant.tracked && variant.policy !== 'continue' && variant.stock < Number(input.value));
      });
      q('[data-quantity]').value = quantity;
      // Keep Shopify's native wallet form independent of the custom cart handler.
      q('[data-express-variant]').value = variant.id;
      q('[data-express-quantity]').value = quantity;
      q('[data-hammock-express]').hidden = busy || !allowed();
      q('[data-each]').textContent = money(each());
      updateCompare(q('[data-compare-each]'), referenceEach, each(), hasComparePrice ? 'Regular price per bed' : 'Price per bed before bundle discount');
      q('[data-total]').textContent = money(each() * quantity);
      q('[data-savings]').hidden = quantity === 1;
      const label = busy ? 'Adding...' : allowed() ? 'Buy Now' : 'Sold out';
      q('[data-buy-label]').textContent = label;
      for (const selector of ['[data-buy]','[data-add]','[data-sticky-buy]']) q(selector).disabled = busy || !allowed();
      q('[data-sticky-buy]').textContent = busy ? 'Adding...' : allowed() ? 'Buy Now \u2192' : 'Sold out';
      q('[data-sticky-title]').textContent = quantity === 1 ? '1 Hammock set' : '2 Hammock sets';
      q('[data-sticky-total]').textContent = money(each() * quantity);
      updateCompare(q('[data-sticky-compare]'), referenceEach * quantity, each() * quantity, hasComparePrice ? `Regular price for ${quantity} ${quantity === 1 ? 'bed' : 'beds'}` : 'Price before bundle discount');
      const original = q('[data-gallery-track] img');
      q('[data-sticky-images]').replaceChildren(...Array.from({length:quantity}, () => {
        const img = document.createElement('img');
        img.src = original.src; img.alt = 'Cream hammock + white cushion'; img.width = 46; img.height = 46; return img;
      }));
      history.replaceState({...history.state,tenloveCatHammock:{product:root.dataset.product,quantity}},'');
    };
    all('[name="hammock_bundle"]').forEach(input => input.addEventListener('change', () => {
      if (busy) return; quantity = Number(input.value); q('[data-error]').hidden = true; update();
    }));
    q('[data-copy-code]').addEventListener('click', async () => {
      const code = q('[data-copy-code]').dataset.copyCode;
      try {await navigator.clipboard.writeText(code); q('[data-copy-label]').textContent = 'Copied';}
      catch (_) {q('[data-copy-label]').textContent = 'Use at checkout';}
      q('[data-copy-status]').textContent = `${code}: enter this code at checkout for 10% off.`;
    });
    const add = async checkout => {
      if (busy || !allowed()) return;
      busy = true; q('[data-error]').hidden = true; update();
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(`${route}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},signal:controller.signal,body:JSON.stringify({items:[{id:variant.id,quantity}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Please check your selection and try again.');
        // Navigate to the native cart/checkout so every existing item and discount is refreshed.
        location.assign(`${route}${checkout ? 'checkout' : 'cart'}`);
      } catch (error) {
        q('[data-error]').textContent = error.name === 'AbortError' || error instanceof TypeError ? 'We could not confirm your cart update. Please check your cart before trying again.' : error.message;
        q('[data-error]').hidden = false; busy = false; update();
      } finally {clearTimeout(timeout);}
    };
    q('[data-hammock-form]').addEventListener('submit', event => {event.preventDefault();event.stopImmediatePropagation();add(true);},true);
    q('[data-add]').addEventListener('click', () => add(false));
    q('[data-sticky-buy]').addEventListener('click', () => add(true));
    window.addEventListener('pageshow', () => {busy=false;update();});
    const track = q('[data-gallery-track]'), slides = all('.tlh-slide');
    let slide = 0;
    const go = index => {
      slide = Math.max(0,Math.min(slides.length-1,index));
      track.scrollTo({left:slide*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant':'smooth'});
    };
    const sync = () => {
      slide = Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));
      q('[data-gallery-count]').textContent = `${slide+1} / ${slides.length}`;
      all('[data-thumb]').forEach(button => button.setAttribute('aria-pressed',String(Number(button.dataset.thumb)===slide)));
    };
    q('[data-prev]').addEventListener('click', () => go(slide-1));
    q('[data-next]').addEventListener('click', () => go(slide+1));
    all('[data-thumb]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.thumb))));
    track.addEventListener('scroll',sync,{passive:true});
    track.addEventListener('keydown', event => {if(event.target.closest('video'))return;if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();go(slide+(event.key==='ArrowRight'?1:-1));}});
    let touch;
    track.addEventListener('touchstart',event=>{const t=event.touches[0];touch={x:t.clientX,y:t.clientY,slide};},{passive:true});
    track.addEventListener('touchend',event=>{if(!touch)return;const t=event.changedTouches[0],dx=t.clientX-touch.x,dy=t.clientY-touch.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5)go(touch.slide+(dx<0?1:-1));touch=null;},{passive:true});
    const updateSticky = () => {
      const top = !coupon.hidden && coupon.classList.contains('is-pinned') ? coupon.getBoundingClientRect().height : 0;
      q('[data-hammock-sticky]').hidden = q('[data-price-anchor]').getBoundingClientRect().bottom > top;
    };
    // Fast swipes can cross the price entirely between intersection observations.
    let stickyFrame;
    const scheduleSticky = () => {
      if (stickyFrame) return;
      stickyFrame = requestAnimationFrame(() => {stickyFrame = null; updateSticky();});
    };
    const observer = new IntersectionObserver(updateSticky);
    observer.observe(q('[data-price-anchor]'));
    window.addEventListener('scroll', scheduleSticky, {passive:true});
    window.addEventListener('resize', scheduleSticky);
    window.addEventListener('pageshow', scheduleSticky);
    const dialog = q('[data-lightbox]');
    all('[data-enlarge]').forEach(button => button.addEventListener('click', () => {
      const img = button.querySelector('img'); q('[data-lightbox-image]').src=img.src;q('[data-lightbox-image]').alt=img.alt;dialog.showModal();
    }));
    q('[data-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){observer.disconnect();couponObserver.disconnect();couponPositionObserver.disconnect();window.removeEventListener('scroll',scheduleSticky);window.removeEventListener('resize',scheduleSticky);window.removeEventListener('pageshow',scheduleSticky);cancelAnimationFrame(stickyFrame);}});
    update();sync();updateSticky();
  };
  document.querySelectorAll('[data-cat-hammock]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cat-hammock]').forEach(init));
})();
